const getMinutesBetweenDates = (date1, date2) => {
  const diff = date2.getTime() - date1.getTime();

  return Math.floor(diff / 60000);
};

export default getMinutesBetweenDates;
